import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PinIconBuilder } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    iconText: string;
}

export const pinIconBuilder: PinIconBuilder = (props: Props) => {
    return props.iconText && <S_Icon icon={['far', props.iconText as IconName]} />;
};

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 19px;
`;
